import { ReactNode } from 'react';
import { MainViewAdmin } from '../ui/main-view-admin/main-view-admin';
import { SideViewAdmin } from '../ui/side-view-admin/side-view-admin';
import { MainViewManager } from '../ui/main-view-manager/main-view-manager';
import { SideViewManager } from '../ui/side-view-manager/side-view-manager';
import { MainViewEmployee } from '../ui/main-view-employee/main-view-employee';
import { SideViewEmployee } from '../ui/side-view-employee/side-view-employee';
import { UserRoles } from '@shared/model/user';

export const MAIN_VIEW_BY_ROLE: Record<UserRoles, ReactNode> = {
    admin: <MainViewAdmin />,
    manager: <MainViewManager />,
    user: <MainViewEmployee />,
};

export const SIDE_VIEW_BY_ROLE: Record<UserRoles, ReactNode> = {
    admin: <SideViewAdmin />,
    manager: <SideViewManager />,
    user: <SideViewEmployee />,
};
